import styled from "styled-components";

export const MainContainer = styled.div`
  width: 100%;

  .gender-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
  }

  @media (min-width: 1000px) {
    width: 80%;
    margin: auto;
  }

  @media (min-width: 1300px) {
    width: 70%;
    margin: auto;
  }
`;

export const TermsContainer = styled.div`
  .label-land {
    font-weight: 500;
    margin-top: 8px;
    margin-bottom: 10px;
  }
  .footer {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    @media screen and (max-width: 768px) {
      gap: 10px;
      margin-top: 0px;
      gap: 0px;
    }

    .check-item {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      @media screen and (max-width: 768px) {
        margin-top: 20px;
      }
    }
    .negative-margin {
      margin-top: 0px;
    }
  }

  .grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0px 20px;
    @media screen and (max-width: 768px) {
      gap: 10px;
    }

    > * {
      flex: 1;
    }

    .label {
      font-weight: 500;
      margin-bottom: 10px;
    }

    .input-container {
      width: 100% !important;
      padding: 5px 0px;
      &:first-child,
      &:nth-child(2) {
        padding-top: 0;
      }

      span.ant-input-group-addon {
        border: 1.5px solid #ccc;
        border-right: 0;
        transition: all 0.3s;
      }

      input {
        width: 100% !important;
        padding: 9px;
        border-radius: 10px;
        border: 1.5px solid #ccc;
        transition: all 0.3s;

        &:focus {
          border-color: #2ecf96;
        }

        &:last-child {
          border-inline-start: 0;
          border-left-width: 0;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }

      /* Focus state for the addon when input is focused */
      &:focus-within span.ant-input-group-addon {
        border-color: #2ecf96;
      }
    }
  }

  @media (min-width: 1000px) {
    .grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
`;
export const Select = styled.select`
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  font-size: 16px;
  background-color: white;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23999%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20class%3D%22feather%20feather-chevron-down%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
`;

export const CountrySelectWrapper = styled.div`
  width: 100%; // Make the wrapper fill available space

  /* Increase border width for Ant Design select */
  :where(.css-dev-only-do-not-override-7p2amn).ant-select-outlined:not(
      .ant-select-customize-input
    )
    .ant-select-selector,
  .ant-select-selector {
    border-width: 1.5px !important; /* Increase from 1px to 2px */
    border-color: ${(props) =>
      props.hasError ? "#ff4d4f" : "#e2e4e9"} !important;
    border-radius: 10px !important;
    min-height: 45px !important;
  }

  /* Target the opened state to maintain thicker border */
  :where(
      .css-dev-only-do-not-override-7p2amn
    ).ant-select-outlined.ant-select-focused:not(.ant-select-disabled):not(
      .ant-select-customize-input
    )
    .ant-select-selector {
    border-width: 2px !important;
    border-color: #2ecf96 !important;
    box-shadow: none !important;
  }

  /* Ensure consistent styling for the ant-select components */
  .ant-select-selection-search {
    display: flex;
    align-items: center;
  }

  .ant-select-selection-placeholder,
  .ant-select-selection-item {
    padding: 8px 0;
    font-size: 16px;
  }

  .country-select__control {
    width: 100%; // Make the control fill the wrapper
    padding: 12px 16px; // Increased padding
    min-height: 50px; // Set minimum height
    border: 2px solid ${(props) => (props.hasError ? "#ff4d4f" : "#e2e4e9")};
    border-radius: 10px;
    box-shadow: none;

    &:hover {
      border-color: ${(props) => (props.hasError ? "#ff4d4f" : "#e2e4e9")};
    }

    &--is-focused {
      /* border-color: #2ecf96 !important; */
      box-shadow: none;
    }
  }

  .country-select__placeholder {
    font-size: 16px; // Larger placeholder text
  }

  .country-select__menu {
    width: 100%; // Make dropdown menu the same width as the control
    z-index: 1000; // Ensure the dropdown appears above other elements
  }

  .country-select__option {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px; // Increase padding for dropdown items
    font-size: 16px; // Larger font size for options
  }

  .country-select__single-value {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px; // Larger font size for selected value
  }

  .country-select__indicator {
    padding: 0 12px; // Increase padding for the dropdown indicators
  }

  .country-select__value-container {
    padding: 2px 12px; // Adjust value container padding
  }
`;
